import { useEffect } from "react";

// Set page-level SEO tags dynamically
export function useSeo({ title, description, canonical, image }) {
  useEffect(() => {
    if (title) document.title = title;
    const setMeta = (selector, attr, content) => {
      if (!content) return;
      let el = document.querySelector(selector);
      if (!el) return;
      el.setAttribute(attr, content);
    };
    setMeta('meta[name="description"]', "content", description);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[name="twitter:title"]', "content", title);
    setMeta('meta[name="twitter:description"]', "content", description);
    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.rel = "canonical";
        document.head.appendChild(link);
      }
      link.href = canonical;
      setMeta('meta[property="og:url"]', "content", canonical);
    }
    if (image) {
      setMeta('meta[property="og:image"]', "content", image);
      setMeta('meta[name="twitter:image"]', "content", image);
    }
  }, [title, description, canonical, image]);
}
